export class EventBus {
  constructor () {
    /**
     * @type {Object.<string, { listener: Function, once: boolean }[]>}
     */
    this.bus = {}
  }

  /**
   *
   * @param {String} event
   * @param {Function} listener
   */
  $on (event, listener) {
    if (this.bus[event]) {
      this.bus[event].push({
        listener
      })
    } else {
      this.bus[event] = [
        {
          listener
        }
      ]
    }
  }

  /**
   *
   * @param {String} event
   * @param {Function} listener
   */
  $once (event, listener) {
    if (this.bus[event]) {
      this.bus[event].push({
        listener,
        once: true
      })
    } else {
      this.bus[event] = [
        {
          listener,
          once: true
        }
      ]
    }
  }

  /**
   * Off listener
   * @param {String} [event]
   * @param {Function} [listener]
   */
  $off (event, listener) {
    if (!event) {
      this.bus = {}
      return
    }

    if (listener) {
      const index = this.bus[event].findIndex(i => i.listener === listener)

      if (index === -1) return

      this.bus[event].splice(index, 1)
    } else {
      delete this.bus[event]
    }
  }

  /**
   * @param {String} event
   * @param  {...any} [args]
   */
  $emit (event, ...args) {
    if (event in this.bus) {
      for (let i = 0, len = this.bus[event].length; i < len; i += 1) {
        if (this.bus[event][i].listener instanceof Function) {
          this.bus[event][i].listener(...args)
        }

        if (this.bus[event][i].once) {
          this.bus[event].splice(i, 1)
          i -= 1
          len -= 1
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/EventBus.js